import { useState } from "react";
import { MAP_CITIES } from "../data/regions";

const REGION_COLORS = {
  "Occitanie": "#2FBF8F",
  "Nouvelle-Aquitaine": "#7dd3c0",
  "Auvergne-Rhône-Alpes": "#9ca3af",
  "Provence-Alpes-Côte d'Azur": "#b8b8b0",
  "Île-de-France": "#d6d6ce",
  "Autres régions": "#6b6b66",
};

export const FranceMap = ({ activeRegion, setActiveRegion }) => {
  const [hovered, setHovered] = useState(null);
  const current = hovered || activeRegion;

  return (
    <div data-testid="france-map" className="relative">
      <svg viewBox="-5 -5 110 105" className="w-full" role="img" aria-label="Carte de France stylisée des zones d'intervention Resineko">
        <polygon
          points="50,2 82,14 92,48 74,88 40,96 12,72 6,36 24,10"
          fill="rgba(244,244,240,0.03)"
          stroke="rgba(244,244,240,0.18)"
          strokeWidth="0.4"
        />
        {MAP_CITIES.map((city) => {
          const isActive = current ? city.region === current : false;
          const isHome = city.home;
          return (
            <g
              key={city.name}
              onMouseEnter={() => setHovered(city.region)}
              onMouseLeave={() => setHovered(null)}
              className="cursor-pointer"
              onClick={() => setActiveRegion(city.region === activeRegion ? null : city.region)}
            >
              <circle cx={city.x} cy={city.y} r={isActive ? 6 : 0} fill={REGION_COLORS[city.region]} opacity="0.15" className="transition-all duration-300" />
              <circle
                cx={city.x}
                cy={city.y}
                r={isHome ? 2.4 : isActive ? 2 : 1.3}
                fill={isHome || isActive ? REGION_COLORS[city.region] : "rgba(244,244,240,0.4)"}
                className="transition-all duration-300"
              />
              {isHome && (
                <circle cx={city.x} cy={city.y} r="4.5" fill="none" stroke="#2FBF8F" strokeWidth="0.4" opacity="0.6" className="animate-pulse-dot" style={{ transformOrigin: `${city.x}px ${city.y}px` }} />
              )}
              <text
                x={city.x}
                y={city.y - 3.4}
                textAnchor="middle"
                fontSize="2.6"
                fill={isHome ? "#2FBF8F" : isActive ? "#F4F4F0" : "rgba(244,244,240,0.45)"}
                className="transition-all duration-300"
                style={{ fontFamily: "Outfit, sans-serif", fontWeight: isHome || isActive ? 500 : 300 }}
              >
                {city.name}
              </text>
            </g>
          );
        })}
      </svg>
      <p className="mt-4 text-center text-xs text-[#8C8C8C]">
        <span className="inline-block h-2 w-2 rounded-full bg-[#2FBF8F] align-middle" />
        <span className="ml-2 align-middle">Daux (31), près de Toulouse — berceau de Resineko</span>
      </p>
    </div>
  );
};
